import { render, staticRenderFns } from "./set-price.vue?vue&type=template&id=cb2f3ae6&scoped=true"
import script from "./set-price.vue?vue&type=script&lang=js"
export * from "./set-price.vue?vue&type=script&lang=js"
import style0 from "./set-price.vue?vue&type=style&index=0&id=cb2f3ae6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2f3ae6",
  null
  
)

export default component.exports